import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-eyes-open",
  "use": "icon-eyes-open-usage",
  "viewBox": "0 0 96 96",
  "content": "<symbol viewBox=\"0 0 96 96\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-eyes-open\">\n    <title>icon/基础图标/可见</title>\n    <g id=\"icon-eyes-open_icon/基础图标/可见\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M48,70.2 C68.434545,70.2 85,48 85,48 C85,48 68.434545,25.8 48,25.8 C27.565455,25.8 11,48 11,48 C11,48 27.565455,70.2 48,70.2 Z\" id=\"icon-eyes-open_路径\" stroke=\"currentColor\" stroke-width=\"10\" />\n        <path d=\"M48,57.25 C53.10859,57.25 57.25,53.10859 57.25,48 C57.25,42.89141 53.10859,38.75 48,38.75 C42.89141,38.75 38.75,42.89141 38.75,48 C38.75,53.10859 42.89141,57.25 48,57.25 Z\" id=\"icon-eyes-open_路径\" stroke=\"currentColor\" stroke-width=\"10\" stroke-linejoin=\"round\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/eyes-open.svg
// module id = 3z2y
// module chunks = 3